import CasesHigh from "assets/CasesHigh";
import { IncidentsTopGridBox } from "modules/flywheel/components/flywheelIncidents/incidents.type";
import CasesMedium from "assets/CasesMedium";
import CasesLow from "assets/CasesLow";
import CasesInformational from "assets/CasesInformational";

/**
 *
 * This function is used to calculate the dashboards for the AnalystDash component
 */
interface Urgency {
  icon: () => JSX.Element;
  description: string;
  count: number;
  circleColor: string;
}

interface Activity {
  description: string;
  count: number;
  circleColor: string;
  percentage: number;
}

interface Result {
  urgencyValues: Urgency[];
  activityValues: Activity[];
}

interface SeverityCount {
  color: string;
  count: number;
}

interface DailyData {
  name: string;
  unclassified: SeverityCount;
  critical: SeverityCount;
  fatal: SeverityCount;
  high: SeverityCount;
  medium: SeverityCount;
  low: SeverityCount;
  informative: SeverityCount;
}


export function getAnalystDashIncidentTrends(events: any) {
  const dailyData = Object();
  if (events.length > 0) {
    for (let i = 0; i < events.length; i ++) {
      const timestamp = Math.round(new Date(events[i]?.createdDate).getTime() / (1000 * 3600 * 24)) * (1000 * 3600 * 24);
      const day = new Date(timestamp).toISOString().slice(0, 10);
      
      if (!dailyData[day]) {
        dailyData[day] = {
            name: day,
            unclassified: {
              color: "FF7800",
              count: 0
            },
            critical: {
              color: "FF7800",
              count: 0
            },
            fatal: {
              color: "FF7800",
              count: 0
            },
            high: {
              color: "FF7800",
              count: 0
            },
            medium: {
              color: "fa69a1",
              count: 0
            },
            low: {
              color: "FFEB32",
              count: 0
            },
            informative: {
              color: "FFEB32",
              count: 0
            }
        };
      }

      dailyData[day][events[i].severity.toLowerCase()]["count"] += 1;
    }
    const sortedData = Object.values(dailyData).sort((b: DailyData, a: DailyData) => new Date(b.name).getTime() - new Date(a.name).getTime());

    return sortedData;
  } else {
    return([
      {
        name: '',
        unclassified: {
          color: "",
          count: 0
        },
        critical: {
          color: "",
          count: 0
        },
        fatal: {
          color: "",
          count: 0
        },
        high: {
          color: "",
          count: 0
        },
        medium: {
          color: "",
          count: 0
        },
        low: {
          color: "",
          count: 0
        },
        informative: {
          color: "",
          count: 0
        }
      }
    ])
  }
}


export function getAnalystDashCasesGridBoxData(t, theme, data: any[], totalCount: number): Result {
  const urgency: Record<string, Urgency> = {
    'fatal': {
      icon: CasesHigh,
      description: t("SEVERITY.FATAL"),
      count: 0,
      circleColor: theme.colors.fatal_criticality
    },
    'critical': {
      icon: CasesHigh,
      description:  t("SEVERITY.CRITICAL"),
      count: 0,
      circleColor: theme.colors.critical_criticality
    },
    'high': {
      icon: CasesHigh,
      description: t("SEVERITY.HIGH"),
      count: 0,
      circleColor: theme.colors.high_criticality
    },
    'medium': {
      icon: CasesMedium,
      description: t("SEVERITY.MEDIUM"),
      count: 0,
      circleColor: theme.colors.medium_criticality
    },
    'low': {
      icon: CasesLow,
      description: t("SEVERITY.LOW"),
      count: 0,
      circleColor: theme.colors.low_criticality
    },
    'informative': {
      icon: CasesInformational,
      description: t("SEVERITY.INFORMATIVE"),
      count: 0,
      circleColor: theme.colors.informative_criticality
    },
    'unclassified': {
      icon: CasesInformational,
      description: t("SEVERITY.OTHER"),
      count: 0,
      circleColor: theme.colors.unclassified_criticality
    },
  }
  
  const activity: Record<string, Activity> = {
    'open': {
      description: "Open",
      count: 0,
      circleColor: theme.colors.open_incident,
      percentage: 0
    },
    'inprogress': {
      description: "In Progress",
      count: 0,
      circleColor: theme.colors.in_progress_incident,
      percentage: 0
    },
    'closed': {
      description: "Closed",
      count: 0,
      circleColor: theme.colors.closed_incident,
      percentage: 0
    },
    'tuningrequested': {
      description: "Request Tuning",
      count: 0,
      circleColor: theme.colors.requested_incident,
      percentage: 0
    },
  };
  
  data.forEach((item) => {    
    if (item.severity) {
      // Add To Urgency Count
      urgency[item.severity.toLowerCase()]["count"] += 1;
    }
  
    if (item.status) {
      // Add to Activity Count
      activity[item.status.toLowerCase().replaceAll(/\s/g,'')]["count"] += 1;
      activity[item.status.toLowerCase().replaceAll(/\s/g,'')]["percentage"] = (
        parseInt(((activity[item.status.toLowerCase().replaceAll(/\s/g,'')]["count"] / totalCount) * 100).toFixed(2))
      )
    }
  });

  const urgencyValues = Object.keys(urgency).map(function(k){return urgency[k]});
  const activityValues = Object.keys(activity).map(function(k){return activity[k]});

  // Return an object with the desired values
  return {
    urgencyValues,
    activityValues,
  };
}